import React from "react";
import "./App.css";
import Header from "./components/Header.tsx";
import Footer from "./components/Footer.tsx";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.tsx";
import Demo from "./pages/Demo.tsx";

// Estimate header height: padding (1rem + 1rem) + logo (36px) approx 60-70px. Let's use 70px.
const HEADER_HEIGHT = "94px";

const App: React.FC = () => (
  <div style={{ backgroundColor: "#fff", color: "#333" }}>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="demo" element={<Demo />} />
    </Routes>
    <Footer />
  </div>
);

export default App;
